import { render } from "./Page404View.vue?vue&type=template&id=30e1e476"
import script from "./Page404View.vue?vue&type=script&lang=js"
export * from "./Page404View.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__